import { defineComponent as _defineComponent } from 'vue'
import { useOrderModel } from '@entities/order'
import { useLoyaltyModel } from '~/src/entities/loyalty'
import { AppButton } from '@shared/ui'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BonusInfo',
  emits: ['closeActiveModalBonus'],
  setup(__props, { emit: emits }) {



const orderModel = useOrderModel()
const loyaltyModel = useLoyaltyModel()

const closeModal = () => {
  emits('closeActiveModalBonus')
}

const textColorStyleLoyalty = computed(() => {
  const loyaltyCode = orderModel.orderData?.global_system_loyalty?.code
  if (loyaltyCode === 'prime_hill') {
    return { color: '#6764FF' }
  } else if (loyaltyCode === 'iiko_card') {
    return { color: '#FF6E65' }
  } else {
    return {}
  }
})

return { __sfc: true,emits, orderModel, loyaltyModel, closeModal, textColorStyleLoyalty, AppButton }
}

})